import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HorizonScanning } from '../../_interfaces/HorizonScanning.model';
import { HorizonScanningAudit } from '../../_interfaces/HorizonScanningAudit.model';
import { RepositoryService } from './../../shared/services/repository.service';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-horizon-scanning-detail',
  templateUrl: './horizon-scanning-detail.component.html',
  styleUrls: ['./horizon-scanning-detail.component.css']
})
export class HorizonScanningDetailComponent {
  constructor(
    private repository: RepositoryService,
    private activeRoute: ActivatedRoute
  ) { }

  private readonly OUTLOOK_DIRECTIONS: { direction, class }[] = [
    {direction: 'Up', class:'fa-arrow-up'},
    {direction:'Down', class:'fa-arrow-down'},
    {direction:'Level', class:'fa-arrows-alt-h'}
  ];

  id$ = this.activeRoute.paramMap.pipe(
    shareReplay(),
    map((paramMap) => paramMap.get('id'))
  );

  horizonScanning$: Observable<HorizonScanning> = this.id$.pipe(
    switchMap((id) => {
      return this.repository.getData(`horizonscanning/${id}`).pipe(
        map((res) => res as HorizonScanning)
      );
    })
  );

  audits$: Observable<HorizonScanningAudit[]> = this.id$.pipe(
    switchMap((id) => {
      return this.repository.getData(`horizonscanning/audit/${id}`).pipe(
        map((res) => res as HorizonScanningAudit[])
      );
    })
  );

  public getOutlookDirectionClass(outlookDirection: string): string {    
    if (outlookDirection) {
      return this.OUTLOOK_DIRECTIONS.find(x => x.direction === outlookDirection).class;
    }
    return;
  }
}
